import clientAxios from "../config";

// Solo incluye Authorization si hay token (auth opcional para donaciones anónimas).
const authHeaders = (token) => (token ? { Authorization: `Bearer ${token}` } : {});

const startCheckout = (token, payload) =>
    clientAxios.post('/api/checkout', payload, {
        headers: authHeaders(token),
    });

const getInvoiceStatus = (uuid) =>
    clientAxios.get(`/api/invoice-status/${uuid}`);

const confirmWompi = (token, uuid, transactionId) =>
    clientAxios.post(`/api/checkout/${uuid}/confirm`, { transaction_id: transactionId }, {
        headers: authHeaders(token),
    });

export {
    startCheckout,
    getInvoiceStatus,
    confirmWompi,
}
